import { jsx } from "react/jsx-runtime";
import { clsx } from "clsx";
import { DEFAULT_DISTANCE_FROM_CONTAINER } from "../constants.js";
const positionClasses = {
    top: 'tw-rotate-180',
    bottom: '-tw-bottom-2',
    left: 'tw-rotate-90',
    right: '-tw-rotate-90'
};
const Triangle = ({ tooltipPosition, offset = DEFAULT_DISTANCE_FROM_CONTAINER })=>{
    const adaptedIdealPositionWithOffset = 'top' === tooltipPosition || 'bottom' === tooltipPosition ? -1 * offset : (offset + 2) * -1;
    const style = {
        [tooltipPosition]: adaptedIdealPositionWithOffset
    };
    return /*#__PURE__*/ jsx("div", {
        className: clsx('tw-absolute tw-w-1.2 tw-overflow-hidden tw-inline-block', positionClasses[tooltipPosition]),
        style: style,
        children: /*#__PURE__*/ jsx("div", {
            className: "tw-h-0.8 tw-w-0.8 tw-bg-neutral-dark-700 dark:tw-bg-neutral-light-200 tw-rotate-45 tw-transform tw-origin-bottom-left"
        })
    });
};
const components_Triangle = Triangle;
export default components_Triangle;
